// Logo CoachOS — SVG inline en currentColor (s'adapte au thème : blanc sur fond sombre).
const Logo = ({ size = 32, className = "" }: { size?: number; className?: string }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 200 215"
    fill="none"
    aria-label="CoachOS"
    role="img"
    className={className}
  >
    <defs>
      <mask id="coachos-logo-mask">
        <rect width="200" height="215" fill="white" />
        <ellipse cx="67" cy="151" rx="24" ry="17" fill="black" transform="rotate(-8 67 151)" />
        <ellipse cx="131" cy="155" rx="17" ry="12" fill="black" transform="rotate(6 131 155)" />
      </mask>
    </defs>
    <path d="M 55 83 A 70 70 0 0 1 163 65" stroke="currentColor" strokeWidth="5.5" strokeLinecap="round" />
    <circle cx="72" cy="93" r="15" fill="currentColor" />
    <circle cx="125" cy="109" r="10.5" fill="currentColor" />
    <g mask="url(#coachos-logo-mask)">
      <ellipse cx="67" cy="151" rx="43" ry="31" fill="currentColor" transform="rotate(-8 67 151)" />
      <ellipse cx="131" cy="155" rx="33" ry="24" fill="currentColor" transform="rotate(6 131 155)" />
      <line x1="74" y1="178" x2="132" y2="122" stroke="currentColor" strokeWidth="20" strokeLinecap="round" />
    </g>
  </svg>
);

export default Logo;
